import { Suspense } from 'react';
import Container from '../../../components/Container';
import { useRoot } from './hooks/useRoot';
import { useStaffList } from './hooks/useStaffList';
import { AllSchoolUsersList } from './components/all-users-list';
import { ManageUsersFilters } from './components/filters';
import { AdminTabs, AdminTabsEnum } from '../components/tabs';

export const ManageStaff = () => {
  const { page: manageUsersPage } = useRoot();
  const {
    staff,
    currentPage,
    totalPages,
    search,
    status,
    loading,
    handlePageChange,
    handleSearchChange,
    handleStatusChange,
  } = useStaffList({
    pageSize: 10,
  });

  const hasUsers = (staff?.length ?? 0) > 0;
  const page = manageUsersPage?.data?.attributes;

  return (
    <Container className="!mt-sh-60">
      <div className="col-span-12 flex flex-col items-start">
        <AdminTabs activeTab={AdminTabsEnum.ManageStaff} />
      </div>
      {!hasUsers && !search && (!status || status === 'all') && (
        <div className="col-span-12 md:col-span-6">
          <div role="note" className="mt-4 rounded-2xl border border-blue-100 bg-blue-50 px-5 py-5 shadow-sm">
            <p className="text-sh-xs font-bold leading-8 text-black-100">{page?.staffEmptyState?.title}</p>
            <p className="mt-2 text-sh-xs text-black">{page?.staffEmptyState?.description}</p>
          </div>
        </div>
      )}
      <div className="col-span-12">
        <h1 className="font-cadiz text-sh-28-32 font-bold">{page?.title}</h1>
        <p className="mt-2 text-sh-xs text-black">{page?.description}</p>

        <ManageUsersFilters
          search={search}
          status={status}
          onSearchChange={handleSearchChange}
          onStatusChange={handleStatusChange}
        />

        {hasUsers && (
          <div className="relative">
            {loading && (
              <div
                className={`absolute inset-0 z-10 flex h-full w-full animate-pulse items-center justify-center rounded-2xl bg-gray-50/50`}>
                <div className="mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600"></div>
              </div>
            )}
            <AllSchoolUsersList
              title={page?.staffListTitle || ''}
              staff={staff}
              totalPages={totalPages}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          </div>
        )}

        {!hasUsers && (search || (status && status !== 'all')) && (
          <div className="mt-8 text-center">
            <p className="text-cj-gray-500 text-sh-xs">No staff members found matching your filters.</p>
          </div>
        )}
      </div>
    </Container>
  );
};

export const ManageStaffScreen = () => {
  return (
    <Suspense fallback={<></>}>
      <ManageStaff />
    </Suspense>
  );
};
